<template>
  <div class="container-size" style="margin-top: 63px">
    <popup :message="alertErrMessage" v-if="isAlertErr" :isError="isError" @close="isAlertErr = false" />
    <div class="hero">
      <div class="content">
        <h1 style="font-size: 40px">{{ $t('technologyService.heroSection.title') }}</h1>
        <p>{{ $t('technologyService.heroSection.description') }}</p>
        <div class="btn-cta">
          <button class="now" @click="scrollToSection('tech_ser')">
            {{ $t('technologyService.heroSection.buttons.collaborateNow') }}
          </button>
          <button class="call" @click="sendToWa">
            {{ $t('technologyService.heroSection.buttons.contactUs') }}
          </button>
        </div>
      </div>
      <div class="card-img">
        <img src="/img/corporate/tech-main.png" width="520" height="" alt="" />
      </div>
    </div>
    <div class="container-fade">
      <div class="left-fade"></div>
      <div class="right-fade"></div>
    </div>
    <div class="logo">
      <h1>{{ $t('technologyService.trustedBy') }}</h1>
      <div class="card" style="overflow-x: none !important">
        <div v-for="(partner, index) in partners" :key="index">
          <div class="logo-card-partner-2">
            <img :src="partner.img_url_web" width="160" />
          </div>
        </div>
      </div>
    </div>

    <div class="container text-center" style="margin-top: 80px">
      <h1 style="margin: 0">{{ $t('technologyService.serviceHeader.title') }}</h1>
      <p style="margin: 0">{{ $t('technologyService.serviceHeader.description') }}</p>
      <div class="card-box">
        <div class="card-1" v-for="(item, idx) in $t('technologyService.descs1')" :key="idx">
          <img :src="item.img" class="img-2" />
          <h3>{{ item.title }}</h3>
          <p>{{ item.desc }}</p>
        </div>
      </div>
    </div>
    <div class="usp">
      <div class="card-usp">
        <h1>{{ $t('technologyService.whyChooseUs.title') }}</h1>
        <p v-html="$t('technologyService.whyChooseUs.description')"></p>
        <div class="card-img">
          <img src="/img/corporate/tech/main-2.png" alt="" />
        </div>
      </div>
      <div class="usp-container">
        <div class="card-usp" v-for="(usp, index) in $t('technologyService.usps')" :key="index">
          <div class="title-container">
            <img class="svg-comment" :src="usp.icon" width="60" height="60" alt="" />
            <h3>{{ usp.title }}</h3>
          </div>
          <div class="content">
            <p>{{ usp.desc }}</p>
          </div>
          <hr />
        </div>
      </div>
    </div>
    <portofolio :title="$t('technologyService.a1')" :portfolios="portfolios" />
    <div class="bg-linear">
      <StepCollaboration :title="$t('technologyService.a2')" :steps="$t('technologyService.steps')" />
      <h1 class="mb-4 text-center">{{ $t('technologyService.a3') }}</h1>
      <div class="inovation">
        <div class="inovation-child" v-for="(item, idx) in $t('technologyService.inovation')" :key="idx">
          <img :src="item.img" alt="IconData">
          <p style="height: 20px; line-height: 16px; font-size: 13px; margin-top: 3px">{{ item.name }}</p>
        </div>
      </div>
    </div>

    <div class="form-konsultasi mt-5" id="tech_ser">
      <div class="header text-center">
        <h1>{{ $t('technologyService.formSection.title') }}</h1>
      </div>

      <div class="sub-heading text-center" style="margin-top: -25px;">
        <p>{{ $t('technologyService.formSection.description') }}</p>
        <v-form class="text-start" style="margin-top: 60px">
          <v-row>
            <v-col cols="6">
              <label class="form-label" for="company">
                {{ $t('technologyService.formSection.labels.companyName') }}
                <span style="color: rgba(184, 15, 10, 1)">*</span>
              </label>
              <v-text-field class="form-input text-form" name="company" v-model="form.corporate_name" outlined
                :placeholder="$t('technologyService.formSection.placeholders.companyName')"></v-text-field>
            </v-col>
            <v-col cols="6">
              <label class="form-label" for="website">
                {{ $t('technologyService.formSection.labels.website') }}
              </label>
              <v-text-field class="form-input text-form" name="website" v-model="form.web_url" outlined
                :placeholder="$t('technologyService.formSection.placeholders.website')"></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6">
              <label class="form-label" for="pic-name">
                {{ $t('technologyService.formSection.labels.picName') }}
                <span style="color: rgba(184, 15, 10, 1)">*</span>
              </label>
              <v-text-field class="form-input text-form" name="pic-name" v-model="form.full_name" outlined
                :placeholder="$t('technologyService.formSection.placeholders.picName')"></v-text-field>
            </v-col>
            <v-col cols="6">
              <label class="form-label" for="occupation">
                {{ $t('technologyService.formSection.labels.occupation') }}
              </label>
              <v-text-field class="form-input text-form" name="occupation" v-model="form.job_pic" outlined
                :placeholder="$t('technologyService.formSection.placeholders.occupation')"></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6">
              <label class="form-label" for="email">
                {{ $t('technologyService.formSection.labels.email') }}
                <span style="color: rgba(184, 15, 10, 1)">*</span>
              </label>
              <v-text-field class="form-input text-form" name="email" v-model="form.email" outlined
                :placeholder="$t('technologyService.formSection.placeholders.email')"></v-text-field>
            </v-col>
            <v-col cols="6">
              <label class="form-label" for="phone-number">
                {{ $t('technologyService.formSection.labels.phoneNumber') }}
                <span style="color: rgba(184, 15, 10, 1)">*</span>
              </label>
              <v-text-field class="form-input text-form" name="phone-number" outlined
                :placeholder="$t('technologyService.formSection.placeholders.phoneNumber')" type="number"
                v-model="form.phone_number" hide-spin-buttons>
                <template v-slot:prepend-inner>
                  <v-row class="d-flex align-center mt-0 ml-7">
                    <img src="/img/other/flag-indonesia.png" alt="" width="30" height="20"
                      style="box-shadow: 2px 2px 3px 1px rgba(13, 28, 113, 0.1)" />
                    <span style="color: #575966" class="mx-3">+62</span>
                  </v-row>
                </template>
              </v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" class="form-collab">
              <label class="form-label" for="collaboration">
                {{ $t('technologyService.formSection.labels.collaborationType') }}
              </label>
              <v-text-field class="form-input text-form" solo flat background-color="rgba(247, 249, 253, 1)"
                :placeholder="$t('technologyService.formSection.placeholders.collaborationType')"
                disabled></v-text-field>
            </v-col>
          </v-row>

          <v-row class="d-flex justify-center align-center mt-3">
            <v-checkbox class="form-input custom-checkbox" v-model="is_confirm">
              <template v-slot:label>
                <p class="label-checkbox" v-html="$t('technologyService.formSection.labels.confirmCheckbox')"></p>
              </template>
            </v-checkbox>
          </v-row>

          <v-row class="d-flex justify-center align-center mt-6">
            <v-btn elevation="0" :class="`btn-kirim ${is_confirm ? 'confirm' : 'reject'}`" @click="onSubmit">
              {{ $t('technologyService.formSection.buttons.submit') }}
            </v-btn>
          </v-row>
        </v-form>
      </div>
    </div>
    <div class="faq" style="margin-top: 60px;">
      <div class="content">
        <div class="row">
          <div class="col-lg-3">
            <div class="header">
              <h1>Frequently Asked Question</h1>
            </div>
          </div>
          <div class="col-lg-9" style="margin-top: 20px;">
            <v-expansion-panels flat class="faq-card" style="padding: 10px; background-color: #F1F6FF;">
              <v-expansion-panel v-for="(item, index) in questions" :key="index"
                style="border-radius: 20px; padding: 0; margin-bottom: 10px;">
                <v-expansion-panel-header disable-icon-rotate @click="openFaq(index, item.title)">
                  <h2 style="margin: 25px 0; font-size: 18px;">{{ item.title }}</h2>
                  <template v-slot:actions>
                    <div class="icon" v-if="item.active">
                      <Arrow />
                    </div>
                    <div v-else>
                      <Arrow :down="!item.active" />
                    </div>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div v-html="item.description"></div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <div style="margin-left: -10px;">
              <div class="btn-stoke-blue" @click="goToFaq">
                <span class="font-poppins">{{ $t('corpAceleration.faqSection.viewMore') }}</span>
                <ArrowLong />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Popup from "@/components/others/Popup.vue";
import StepCollaboration from '../../StepCollaboration.vue';
import Portofolio from '../../Portofolio.vue';
import Arrow from '@/assets/icons/Arrow.vue';
import ArrowLong from '@/assets/icons/ArrowLong.vue';

export default {
  components: {
    Popup,
    StepCollaboration,
    ArrowLong,
    Portofolio,
    Arrow
  },
  name: "TechnologyServiceDesktop",
  data() {
    return {
      portofolio: 0,
      portofolioLength: 4,
      partnership: 0,
      partnershipLength: 3,
      images1: [
        { img: "/img/corporate/telkomsat.png" },
        { img: "/img/corporate/astra.png" },
        { img: "/img/corporate/pru.png" },
        { img: "/img/corporate/bank.png" },
        { img: "/img/corporate/astrapay.png" },
        { img: "/img/corporate/solusi.png" },
      ],
      images2: [
        {
          img: "/img/corporate/banner-2.png",
        },
      ],
      showed: [],
      partners: [],
      portfolios: [],
      questions: [],
      testimonies: [],
      alertErrMessage: "",
      isAlertErr: false,
      is_confirm: false,
      isError: false,
      form: {
        full_name: "",
        email: "",
        phone_number: "",
        gender: "",
        corporate_name: "",
        company_field: "",
        program: "",
        total_student: 0,
        notes: "",
        category: "SERVICES",
        web_url: "",
        job_pic: ""
      },
    };
  },
  watch: {
    "$i18n.locale"() {
      this.getPortofolio();
      this.getFaq();
    }
  },
  methods: {
    sendToWa() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Contact Us - WhatsApp - Technology Service',
        value: 1,
      });
      window.open(
        "https://api.whatsapp.com/send/?phone=6282127274632&text=Hi%20Kak%20HiColleagues,%20saya%20mau%20bertanya",
        "_blank"
      );
    },
    scrollToSection(sectionId) {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Collaborate Now - Scroll to Form - Technology Service',
        value: 1,
      });
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    },
    async getClientLogo() {
      try {
        const resp = await this.$http.get("/v1/logo?category=SERVICES");
        this.partners = resp.data.data.logos;
        this.duptlicatePartners();
      } catch (err) {
        console.log(err);
      }
    },
    duptlicatePartners() {
      this.partners = this.partners.concat(this.partners, this.partners, this.partners);
    },
    async getPortofolio() {
      try {
        const resp = await this.$http.get(`/v1/project-portfolio?category=SERVICES&is_main=true`);
        this.portfolios = resp.data.data.project_portfolios;
      } catch (err) {
        console.log(err);
      }
    },
    openFaq(idx, title) {
      this.$gtag.event('click', {
        event_category: 'FAQ',
        event_label: `Open FAQ - ${title} - Technology Service`,
        value: 1,
      });
      const valDef = this.questions[idx].active;
      this.questions.forEach(e => {
        e.active = false;
      });
      this.questions[idx].active = !valDef;
    },
    async getFaq() {
      this.questions = [];
      try {
        const resp = await this.$http.get(`/v1/faq?category=SERVICES&is_main=true`);
        this.questions = resp.data.data.faq.map((item) => ({
          description: item.answer[0],
          title: item.question,
          active: false
        }));
      } catch (err) {
        console.log(err);
      }
    },
    async onSubmit() {
      this.$gtag.event('click', {
        event_category: 'Form',
        event_label: 'Submit Technology Service Form',
        value: 1,
      });
      if (!this.is_confirm) {
        return;
      }
      if (!this.form.corporate_name || !this.form.full_name || !this.form.job_pic || !this.form.email || !this.form.phone_number || !this.form.category || !this.form.web_url) {
        this.alertErrMessage = "Harap isi semua form yang tersedia";
        this.isAlertErr = true;
        this.isError = true;
        this.$gtag.event('form_submission', {
          event_category: 'Form',
          event_label: 'Technology Service Form Submission Error',
          value: 0,
        });
        return;
      }
      try {
        await this.$http.post('/v1/corporate-registration', this.form);
        this.alertErrMessage = "Success";
        this.isAlertErr = true;
        this.isError = false;
        this.clearForm();
        this.$gtag.event('form_submission', {
          event_category: 'Form',
          event_label: 'Technology Service Form Submission Success',
          value: 1,
        });
      } catch {
        this.alertErrMessage = "Error saat submit data";
        this.isAlertErr = true;
        this.isError = true;
        this.$gtag.event('form_submission', {
          event_category: 'Form',
          event_label: 'Technology Service Form Submission Error',
          value: 0,
        });
      }
    },
    goToFaq() {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: 'View More FAQs - Technology Service',
        value: 1,
      });
      this.$router.push('/faq');
    },
    clearForm() {
      this.is_confirm = false;
      this.form.full_name = "";
      this.form.email = "";
      this.form.phone_number = "";
      this.form.corporate_name = "";
      this.form.category = "";
      this.form.web_url = "";
      this.form.job_pic = "";
    },
  },
  mounted() {
    this.getClientLogo();
    this.getPortofolio();
    this.getFaq();
  }
};
</script>

<style src="./technologyService.css" scoped></style>